angular.module('unergie.main')
.controller('mediaManagerCtrl', ($scope, $uibModalInstance, images, Upload, DataAccessMedias, $timeout, $uibModal, AlertManager) => {
    $scope.images = images
    $scope.progressPercentage = 0
    $scope.uploadedMessage = 0

    $scope.filename = ''

    $scope.$watch('files', (files) => $scope.upload(files))

    $scope.upload = function (files) {
        if (files && files.length) {
            for (let i = 0; i < files.length; i++) {
                Upload.rename(files[i], files[i].name.replace(/ /g, '_'))
                Upload.upload({
                    url: '/uploads/website-extras/images',
                    data: { file: files[i] },
                }).then((resp) => $scope.images.push(resp.data.url), (resp) => console.log(`Error status: ${resp.status}`))
            }
        }
    }

    $scope.showButtons = (index) => {
        $scope.imageVisible = index
    }

    $scope.getProgressBarStyle = () => ({ width: `${$scope.progressPercentage}%`, display: 'inline-block', height: '35px' })

    $scope.delete = function (file) {
        const imageName = file.split('/').pop()
        return DataAccessMedias.deleteImage({ id: imageName }).$promise
        .then((data) => {
            AlertManager.success('L\'image a été supprimée avec succés')
            _.pull($scope.images, file)
        })
    }


    $scope.imageFullSize = function (image) {
        $uibModal.open({
            animation: true,
            templateUrl: '/imageFullSize',
            controller: 'imageFullSizeCtrl',
            size: 'xlg',
            resolve: {
                image() {
                    return image
                },
            },
        })
    }

    $scope.addImageToEditor = function (image) {
        const elem = angular.element(document.getElementById('ckeditor'))
        const ckeditorInstance = elem.controller('ckeditor').instance
        const modalInstance = $uibModal.open({
            animation: true,
            templateUrl: '/insertImageConf',
            controller: 'insertImageConfCtrl',
            size: 'md',
            resolve: {
                editor() {
                    return ckeditorInstance
                },
                image() {
                    return image
                },
            },
        })
        return modalInstance.result.then(() => AlertManager.success('L\'image a été ajoutée à l\'éditeur'))
    }


    $scope.ok = () => $uibModalInstance.close()
}).controller('imageFullSizeCtrl', ($scope, $uibModalInstance, image, $uibModal) => {
    $scope.image = image
    $scope.ok = () => $uibModalInstance.close()
}).controller('insertImageConfCtrl', ($scope, $uibModalInstance, image, editor, $uibModal) => {
    $scope.image = image
    $scope.editor = editor
    $scope.imageTypes = [
        {
            label: 'Image de fond',
            value: 'background',
        },
        {
            label: 'Image flottante',
            value: 'floating',
        },
    ]
    $scope.imageConf = {
        class: '',
        customStyle: '',
    }

    $scope.ok = function () {
        let htmlToInsert = ''
        switch ($scope.imageConf.imageType) {
            case 'background': htmlToInsert += `${`<div class="${$scope.imageConf.class}" style="background:url(${$scope.image}` +
                ') no-repeat;background-size: cover;background-position:fixed;height:100vh;width:100vw;'}${$scope.imageConf.customStyle}"><p></p></div>`
                break
            case 'floating':
            default: htmlToInsert += `<img class="${$scope.imageConf.class}" src="${$scope.image}" style="${$scope.imageConf.customStyle}"/>`
        }

        $scope.editor.insertHtml(htmlToInsert)
        return $uibModalInstance.close()
    }

    $scope.dismiss = () => $uibModalInstance.dismiss()
})
